var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticClass:"fl-sym-rounded fl-custom-map",attrs:{"width":"100%","height":"150","frameborder":"0","scrolling":"no","marginheight":"0","marginwidth":"0","id":"gmap_canvas","src":_vm.mapSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }